import React, { useRef, useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { HrFlexContainer, HrFontRegular, HrGreen, HrParagraph, HrRed } from '@components/styles/hr-styles';
import { Checkbox } from '@components/form/checkbox';
import { useTranslation, Trans } from 'react-i18next';
import styled from 'styled-components';
import useStore from '../../store/useStore';
import { DisplaySettingsContext } from '../../store/display-settings';

const FlexContainer = styled(HrFlexContainer)`
  flex-direction: column;
  align-items: flex-start;
  padding: 0 32px;

  @media (max-width: 768px) {
    padding: 0 16px;
  }
`;

const Link = styled.a`
  color: ${HrGreen};
  display: flex;
  text-decoration: none;
  font-weight: 600;
  font-family: 'Open Sans', sans-serif; ;
`;

export const TermsConditions = observer(({ formState, control }) => {
  const [t] = useTranslation();
  const refLabel = useRef('termsConditions.hiring');
  const ref = useRef('termsConditions.bumeran');
  const { protocol } = window.location;
  const { host } = window.location;
  const { getDataPostulant } = useStore();
  const { darkMode, fontSizeSetting } = useContext(DisplaySettingsContext);

  const CustomLabel = () => {
    return (
      <Trans i18nKey='userMessagesUnread'>
        <HrFlexContainer justifyContent='flex-start' gap='4px'>
          <HrParagraph
            margin='0 0 0 6px'
            cursor='pointer'
            fontSizeSetting={fontSizeSetting}
            onClick={() => refLabel.current.click()}
            fontWeight={HrFontRegular}
            color={darkMode ? 'white' : ''}
          >
            {t('postulant.terms_and_conditions.read')}
          </HrParagraph>
          <Link href={`${protocol}//${host}/hiringroom/politica_de_privacidad`} target='_blank'>
            {t('postulant.terms_and_conditions.politics')}
            <span style={{ color: HrRed }}> *</span>
          </Link>
        </HrFlexContainer>
      </Trans>
    );
  };

  return (
    <FlexContainer>
      {getDataPostulant.allowBumeranPostulation && (
        <Checkbox
          label={t('postulant.terms_and_conditions.bumeran')}
          name='termsConditions.bumeran'
          refCustom={ref}
          control={control}
          validate={{ required: false }}
          defaultChecked
          formState={formState}
        />
      )}
      <Checkbox
        name='termsConditions.hiring'
        refCustom={refLabel}
        control={control}
        validate={{ required: true, TermsConditions: true }}
        defaultChecked={false}
        formState={formState}
        customLabel
      >
        <CustomLabel />
      </Checkbox>
    </FlexContainer>
  );
});
